"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAiModelModel = void 0;
exports.OpenAiModelModel = {
    O1Preview: "o1-preview",
    O1Preview20240912: "o1-preview-2024-09-12",
    O1Mini: "o1-mini",
    O1Mini20240912: "o1-mini-2024-09-12",
    Gpt4ORealtimePreview20241001: "gpt-4o-realtime-preview-2024-10-01",
    Gpt4ORealtimePreview20241217: "gpt-4o-realtime-preview-2024-12-17",
    Gpt4OMiniRealtimePreview20241217: "gpt-4o-mini-realtime-preview-2024-12-17",
    Gpt4OMini: "gpt-4o-mini",
    Gpt4OMini20240718: "gpt-4o-mini-2024-07-18",
    Gpt4O: "gpt-4o",
    Gpt4O20240513: "gpt-4o-2024-05-13",
    Gpt4O20240806: "gpt-4o-2024-08-06",
    Gpt4O20241120: "gpt-4o-2024-11-20",
    Gpt4Turbo: "gpt-4-turbo",
    Gpt4Turbo20240409: "gpt-4-turbo-2024-04-09",
    Gpt4TurboPreview: "gpt-4-turbo-preview",
    Gpt40125Preview: "gpt-4-0125-preview",
    Gpt41106Preview: "gpt-4-1106-preview",
    Gpt4: "gpt-4",
    Gpt40613: "gpt-4-0613",
    Gpt35Turbo: "gpt-3.5-turbo",
    Gpt35Turbo0125: "gpt-3.5-turbo-0125",
    Gpt35Turbo1106: "gpt-3.5-turbo-1106",
    Gpt35Turbo16K: "gpt-3.5-turbo-16k",
    Gpt35Turbo0613: "gpt-3.5-turbo-0613",
};
